import React, { useState, useMemo } from 'react';
import { I18n, translate } from '@td/shared_utils';
import moment from 'moment';

import { SearchIcon } from '../../../icons';
import { Medication } from '../../types/medication';

const MedicationNdcLookup = ({ drug }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredData = useMemo(
    () => drug.ndcCoreDescriptions.filter(ndcCoreDescription => ndcCoreDescription.ndcFormatted.includes(searchQuery)),
    [searchQuery]
  );

  return (
    <section className="ndc-lookup">
      <div className="search-ndc">
        <div className="input-container">
          <SearchIcon className="input-icon" />
          <input
            className="react-autosuggest__input"
            type="search"
            placeholder={translate(null, 'medication_formularies.details.ndc_lookup', 'placeholder')}
            value={searchQuery}
            onChange={event => setSearchQuery(event.target.value.trim())}
          />
        </div>
        {filteredData.length === 0 && searchQuery && (
          <div className="alert-box mt-4">
            <I18n scope="medication_formularies.details.ndc_lookup" text="no_results_text" />
          </div>
        )}
      </div>
      <table className="fields ndc-table">
        <tbody>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.ndc_lookup.headers" text="ndc_number" />
            </th>
            <th>
              <I18n scope="medication_formularies.details.ndc_lookup.headers" text="obsolete_date" />
            </th>
          </tr>
          {filteredData.map(ndc => (
            <tr key={ndc.ndcFormatted}>
              <td>{ndc.ndcFormatted}</td>
              <td>
                {ndc.obsoleteDate ? (
                  moment.utc(ndc.obsoleteDate).format('L')
                ) : (
                  <span className="obsolete-date-placeholder">
                    {translate(null, 'medication_formularies.details.ndc_lookup', 'obsolete_date_placeholder')}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

MedicationNdcLookup.propTypes = {
  drug: Medication
};

export default MedicationNdcLookup;
